// extracted by mini-css-extract-plugin
module.exports = {"iconTooltipBox":"styles_iconTooltipBox__1vy4h","tooltipBox":"styles_tooltipBox__2EAcc"};